module.exports = __webpack_public_path__ + "img/pensando.28f3aac4.png";